"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityPermissionsField = exports.entityBannerField = exports.entityLinkedTableField = void 0;
var react_1 = __importDefault(require("react"));
var sprintf_js_1 = require("sprintf-js");
var pluralize_1 = require("pluralize");
var entity_linked_select_field_1 = require("./entity-linked-select-field");
var input_related_entity_1 = require("../components/forms/input-related-entity");
var entity_field_1 = require("./entity-field");
var entityLinkedTableField = function (args) {
  var name = args.name,
    placeholder = args.placeholder,
    label = args.label,
    description = args.description,
    entityTypeName = args.entityTypeName,
    context = args.context,
    canCreate = args.canCreate,
    _a = args.fieldSet,
    fieldSet = _a === void 0 ? 'overview' : _a,
    variant = args.variant;
  var isMulti = args.isMulti === undefined ? (0, pluralize_1.isPlural)(name) : args.isMulti;
  var isSortable = args.isSortable === undefined ? true : args.isSortable;
  var entities = context.entities,
    t = context.t,
    definition = context.definition;
  var selectEntityDefinition = entities[entityTypeName];
  //if (variant && variant !== `for${context.entityTypeName}`) {
  // console.log(args, definition.name);
  // if (context.metadata && context.metadata.variant === `for${entityTypeName}`) {
  //   return null;
  // }
  // if (variant && context.metadata && context.metadata.variant !== variant) {
  // }
  return __assign(__assign({}, (0, entity_field_1.entityFieldArgs)(args)), {
    name: name,
    fieldSet: fieldSet,
    placeholder: placeholder && t(placeholder) || selectEntityDefinition && (isMulti ? (0, sprintf_js_1.sprintf)(t("Select one or more %s"), selectEntityDefinition.pluralLabel) : (0, sprintf_js_1.sprintf)(t("Select %s"), selectEntityDefinition.aLabel)),
    label: label && t(label) || selectEntityDefinition && (isMulti ? t(selectEntityDefinition.pluralLabel) : t(selectEntityDefinition.label)),
    description: description && t(description) || selectEntityDefinition && (isMulti ? (0, sprintf_js_1.sprintf)(t("Does this %s have any associated %s?"), definition.label, selectEntityDefinition.pluralLabel) : (0, sprintf_js_1.sprintf)(t("Does this %s have an associated %s?"), definition.label, selectEntityDefinition.label)),
    render: function (props) {
      return react_1.default.createElement(input_related_entity_1.InputRelatedEntity, __assign({}, props, {
        isSingle: !isMulti,
        isSortable: isSortable,
        entityTypeName: entityTypeName,
        context: context
      }));
    }
  });
};
exports.entityLinkedTableField = entityLinkedTableField;
var entityBannerField = function (args) {
  return (0, entity_linked_select_field_1.entityLinkedSelectField)(__assign(__assign({
    fieldSet: 'overview',
    name: 'banner',
    description: (0, sprintf_js_1.sprintf)(args.context.t('Specify a set of images for this %s for display in listing and detail pages.'), args.context.definition.label)
  }, args), {
    entityTypeName: 'Banner'
  }));
};
exports.entityBannerField = entityBannerField;
var entityPermissionsField = function (args) {
  var context = args.context;
  var t = context.t;
  return context.currentUserCan('write:any') && (0, exports.entityLinkedTableField)(__assign(__assign({
    label: 'Permissions',
    description: (0, sprintf_js_1.sprintf)(t('Grant other People access to read, edit, or administer this %s'), context.definition.label),
    fieldSet: 'admin'
  }, args), {
    name: 'permissions',
    entityTypeName: 'Permission'
  }));
};
exports.entityPermissionsField = entityPermissionsField;